import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "w-100 row overflow-hidden"
}
const _hoisted_2 = { class: "col-lg-5" }
const _hoisted_3 = {
  class: "w-100 d-flex justify-content-center",
  style: {"border-bottom":"1px dashed #ccc"}
}
const _hoisted_4 = { class: "mb-5 text-gray-600" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-lg-6",
  style: {"border-right":"1px dashed #ccc"}
}
const _hoisted_7 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_8 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_11 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column gap-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-long fa-2xl" })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-long fa-2xl" })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-long fa-2xl" })
    ])
  ])
], -1)
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = {
  class: "",
  style: {"border-bottom":"1px dashed #ccc"}
}
const _hoisted_15 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_16 = { class: "mb-5 text-gray-800" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "col-lg-6",
  style: {"border-right":"1px dashed #ccc"}
}
const _hoisted_19 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_20 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_23 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_24 = {
  key: 0,
  style: {"border-top":"1px dashed #ccc"}
}
const _hoisted_25 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_26 = { class: "w-100 mt-5 d-flex justify-content-center" }

import { computed, inject, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import { AccountGroupTypes } from "@/core/types/AccountGroupTypes";
import { Search } from "@element-plus/icons-vue";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeSalesOrAgentForm',
  emits: ["re-assign-finished"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();

const newAgentGroupName = ref(null);
const newSalesGroupName = ref(null);
const { t } = useI18n();
const account = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const accountDetails = ref(account);
const formData = ref<any>({ name: "" });

const validInput = (value: string) =>
  value !== "" && value !== undefined && value !== null;
const validateIbSelfGroup = async (value: any) => {
  isSubmitting.value = true;
  if (!validInput(value)) {
    isSubmitting.value = false;
    return false;
  }

  if (value?.length < 3) {
    MsgPrompt.warning(t("tip.ibGroupLengthShouldBeAtLeast3"));
    isSubmitting.value = false;
    return false;
  }

  const { data } = await AccountService.queryAccounts({
    group: value,
    roles: [AccountRoleTypes.IB, AccountRoleTypes.Broker],
  });

  const exists = data?.length > 0;

  if (exists) {
    MsgPrompt.warning(t("tip.ibGroupExists"));
    isSubmitting.value = false;
    return false;
  }

  isSubmitting.value = false;
  return true;
};



const show = async () => {
  isLoading.value = true;
  modalRef.value?.show();

  if (!account) {
    MsgPrompt.error("Account not injected");
    return;
  }

  const { data } = await AccountService.queryAccounts({
    id: account.value.id,
  });
  if (data?.length === 0) {
    MsgPrompt.error("Account not found");
    return;
  }
  accountDetails.value = data[0];
  if (
    [AccountRoleTypes.IB, AccountRoleTypes.Broker].includes(
      accountDetails.value.role
    )
  ) {
    formData.value.name = accountDetails.value.group;
    formData.value.groupId = accountDetails.value.agentGroupId;
    formData.value.ownerAccountId = accountDetails.value.id;
  }
  clearNewSalesAccount();
  clearNewAgentAccount();

  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

const submit = async () => {
  try {
    //
  } catch (error) {
    MsgPrompt.error(error);
  }
  hide();
};

let prevAgentGroupStr = "";
let prevAgentGroupList = [];
const queryAgentGroupAsync = async (
  queryString: string,
  cb: (arg: any) => void
) => {
  if (prevAgentGroupStr === queryString) {
    cb(prevAgentGroupList);
    return;
  }

  const res = await AccountService.getFullAccountGroupNames(
    AccountGroupTypes.Agent,
    queryString == "null" ? "" : queryString
  );
  prevAgentGroupStr = queryString;
  prevAgentGroupList = res.map((item) => ({ value: item, label: item }));
  cb(prevAgentGroupList);
};

let prevSalesGroupStr = "";
let prevSalesGroupList = [];
const querySalesGroupAsync = async (
  queryString: string,
  cb: (arg: any) => void
) => {
  if (prevSalesGroupStr === queryString) {
    cb(prevSalesGroupList);
    return;
  }
  const res = await AccountService.getFullAccountGroupNames(
    AccountGroupTypes.Sales,
    queryString == "null" ? "" : queryString
  );
  prevSalesGroupStr = queryString;
  prevSalesGroupList = res.map((item) => ({ value: item, label: item }));
  cb(prevSalesGroupList);
};

const newSalesAccount = ref({} as any);
const getNewSalesAccount = async () => {
  if (newSalesGroupName.value === null || newSalesGroupName.value === "") {
    clearNewSalesAccount();
    clearNewAgentAccount();
    return;
  }
  const res = await AccountService.queryAccounts({
    role: AccountRoleTypes.Sales,
    code: newSalesGroupName.value,
  });
  if (res.data.length === 0) {
    MsgPrompt.error("Sales account not found");
    return;
  }
  newSalesAccount.value = res.data[0];
  clearNewAgentAccount();
};

const newAgentAccount = ref({} as any);
const getNewAgentAccount = async () => {
  if (newAgentGroupName.value === null || newAgentGroupName.value === "") {
    clearNewSalesAccount();
    clearNewAgentAccount();
    return;
  }
  const res = await AccountService.queryAccounts({
    role: AccountRoleTypes.IB,
    group: newAgentGroupName.value,
  });
  if (res.data.length === 0) {
    MsgPrompt.error("Agent account not found");
    return;
  }
  newAgentAccount.value = res.data[0];
  newSalesGroupName.value = newAgentAccount.value.code;
  newSalesAccount.value = {
    id: newAgentAccount.value.salesAccount.id,
    name: newAgentAccount.value.salesAccount.name,
  };
};

const clearNewSalesAccount = () => {
  newSalesAccount.value = {} as any;
  newSalesGroupName.value = null;
};

const clearNewAgentAccount = () => {
  newAgentAccount.value = {} as any;
  newAgentGroupName.value = null;
};

const isSubmitting = ref(false);
const submitSalesAndAgentReAssign = async () => {
  try {
    isSubmitting.value = true;
    let actions = "";
    if (shouldRemoveAgent.value) {
      await AccountService.removeAccountFromAgent(
        accountDetails.value.id,
        accountDetails.value.agentAccount.id
      );
      actions += "Remove agent => ";
    }

    if (shouldReAssignSales.value) {
      await AccountService.assignAccountToSales(
        accountDetails.value.id,
        newSalesAccount.value.id
      );
      actions += "Re-assign sales => ";
    }

    if (shouldReAssignAgent.value) {
      await AccountService.assignAccountToAgent(
        accountDetails.value.id,
        newAgentAccount.value.id
      );
      actions += "Re-assign agent & sales => ";
    }

    if (
      shouldRenameAgentSelfGroupName.value &&
      (await validateIbSelfGroup(formData.value.name))
    ) {
      await AccountService.renameSelfGroupName(
        formData.value.groupId,
        formData.value
      );
      actions += "Rename agent self group => ";
    }
    MsgPrompt.success(actions)
      .then(() => hide())
      .then(() => {
        emits("re-assign-finished");
      });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const shouldRemoveAgent = computed(
  () =>
    (newAgentGroupName.value === null || newAgentGroupName.value === "") &&
    accountDetails.value.agentAccount.id !== 0
);

const shouldReAssignSales = computed(
  () =>
    newSalesGroupName.value !== null &&
    newSalesGroupName.value !== "" &&
    newSalesAccount.value.id !== accountDetails.value.salesAccount.id
);

const shouldReAssignAgent = computed(
  () =>
    newAgentGroupName.value !== null &&
    newAgentGroupName.value !== "" &&
    newAgentAccount.value.id !== accountDetails.value.agentAccount.id
);

const shouldRenameAgentSelfGroupName = computed(
  () =>
    [AccountRoleTypes.IB, AccountRoleTypes.Broker].includes(
      accountDetails.value.role
    ) && accountDetails.value.group !== formData.value.name
);

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.changeSalesOrIb'),
    "is-loading": isLoading.value,
    submit: submit,
    style: {"width":"1000px"},
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(LoadingCentralBox, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("title.currentSalesAndIb")), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: accountDetails.value.salesAccount.group,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountDetails.value.salesAccount.group) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("fields.salesInfo")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: accountDetails.value.salesAccount.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountDetails.value.salesAccount.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("fields.ibGroup")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: accountDetails.value.agentAccount.group,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accountDetails.value.agentAccount.group) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.ibInfo")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: accountDetails.value.agentAccount.name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accountDetails.value.agentAccount.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t("title.newSalesAndIb")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          clearable: "",
                          modelValue: newSalesGroupName.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newSalesGroupName).value = $event)),
                          "fetch-suggestions": querySalesGroupAsync,
                          onBlur: getNewSalesAccount,
                          disabled: 
                    newAgentGroupName.value !== null && newAgentGroupName.value !== ''
                  
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              icon: _unref(Search) as any
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.salesInfo")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: newSalesAccount.value.name,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newSalesAccount.value.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("fields.ibGroup")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          clearable: "",
                          modelValue: newAgentGroupName.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newAgentGroupName).value = $event)),
                          "fetch-suggestions": queryAgentGroupAsync,
                          onBlur: getNewAgentAccount
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              icon: _unref(Search) as any
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("fields.ibInfo")), 1),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          modelValue: newAgentAccount.value.name,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newAgentAccount.value.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (accountDetails.value.role === _unref(AccountRoleTypes).IB)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("fields.ibSelfGroup") + " (For IB's own group)"), 1),
                          _createVNode(_component_el_form_item, { props: "ibSelfGroupName" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: formData.value.name,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.name) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_el_button, {
                    loading: isSubmitting.value,
                    type: "primary",
                    onClick: submitSalesAndAgentReAssign
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_el_button, {
                    onClick: hide,
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})